<template>
  <div class="default-main ba-table-box">
    <buttons
        :buttons="['columnDisplay', 'add', ]"
        :access="['', '015003001', ]"
        :tableData="tableData"
        @btnClick="btnClick"
    ></buttons>

    <tables :tableData="tableData" :tableKey="$options.name"></tables>

    <el-dialog
        v-model="dialogFormData.state"
        width="760px"
        class="target-manage-dialog finance-record-dialog"
        destroy-on-close
        draggable
        align-center
        :close-on-click-modal="false"
    >
      <template #header>
        <div class="target-dialog-header">
          <div class="target-title-block">
            <h3>{{ dialogFormData.title }}</h3>
          </div>
        </div>
      </template>

      <el-form
          ref="recordForm"
          :model="dialogFormData.data"
          :rules="dialogFormData.rules"
          label-width="86px"
          class="finance-record-form"
      >
        <div class="finance-record-grid">
          <el-form-item label="标题" prop="incomeProject">
            <el-input v-model.trim="dialogFormData.data.incomeProject" clearable maxlength="12" show-word-limit placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="详情" prop="note" class="finance-record-form-item-full">
            <el-input
                v-model="dialogFormData.data.note"
                type="textarea"
                maxlength="200"
                show-word-limit
                :rows="3"
                placeholder="请输入详情"
            ></el-input>
          </el-form-item>
          <el-form-item label="收款方式" prop="payMode">
            <el-select v-model="dialogFormData.data.payMode" clearable placeholder="请选择收款方式">
              <template #prefix>
                <el-image
                    v-if="getPayModeIcon(dialogFormData.data.payMode)"
                    class="finance-pay-icon"
                    :src="getPayModeIcon(dialogFormData.data.payMode)"
                ></el-image>
              </template>
              <el-option
                  v-for="item in receiveModeList"
                  :key="item.logicValue"
                  :label="item.displayValue"
                  :value="item.logicValue"
              >
                <div class="finance-pay-option">
                  <el-image
                      v-if="getPayModeIcon(item.logicValue)"
                      class="finance-pay-icon"
                      :src="getPayModeIcon(item.logicValue)"
                  ></el-image>
                  <span>{{ item.displayValue }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="recordTime">
            <el-date-picker
                v-model="dialogFormData.data.recordTime"
                type="date"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="收款金额" prop="incomeAmount">
            <el-input
                v-model.trim="dialogFormData.data.incomeAmount"
                clearable
                maxlength="10"
                placeholder="请输入收款金额"
                @input="handleMoneyInput('incomeAmount')"
            >
              <template #append>元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>

      <template #footer>
        <div class="target-footer-actions is-edit">
          <el-button class="target-close-action" @click="dialogFormData.state = false">取 消</el-button>
          <el-button type="primary" class="target-save-action is-visible" @click="submitRecordForm">保 存</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import buttons from '@/components/buttons.vue'
import tables from '@/components/tables.vue'

export default {
  name: "income",
  components: {
    buttons,
    tables,
  },
  data() {
    return {
      records: [],
      receiveModeList: [],
      allowedReceiveModeList: [
        {displayValue: '微信', logicValue: 2},
        {displayValue: '支付宝', logicValue: 3},
        {displayValue: '现金', logicValue: 4},
        {displayValue: '银行卡', logicValue: 5},
        {displayValue: '其他', logicValue: 6},
      ],
      tableData: {
        form: {
          page: 1,
          limit: this.$tools.getLimit(this.$options.name),
          total: 0,
          incomeProject: '',
          payMode: '',
          orderNo: '',
          recordTime: [],
        },
        column: [
          {type: 'selection'},
          {type: 'index'},
          {label: "订单号", prop: 'orderNo', type: 'text', show: true,  width: 160},
          {label: "日期", prop: 'recordTime', type: 'time', show: true, condition: "dates", width: 155, sort: true},
          {label: "标题", prop: 'incomeProject', type: 'text', show: true, width: 180},
          {label: "详情", prop: 'note', type: 'textLong', show: true},
          {
            label: "收款方式",
            prop: 'payModeDisplay',
            type: 'html',
            show: true,
            width: 150,
            tags: [],
            extraProp: 'payMode',
            placeholder: ' ',
            searchChange: () => {
              this.searchClick();
            },
          },
          {label: "收款金额", prop: 'incomeAmount', type: 'text', show: true, width: 110, sum: true},
          {label: "操作人", prop: 'operateUserName', type: 'text', show: true, width: 110},
          {
            type: 'button',
            label: "操作",
            autoWidth: true,
            minWidth: 120,
            maxWidth: 160,
            moreButtons: ['delete'],
            buttonAlign: 'left',
            buttons: [
              {label: '审核', prop: 'audit', type: 'primary', showText: true, access: '015003003'},
              {label: '反审', prop: 'revAudit', type: 'success', showText: true, access: '015003004'},
              {label: '编辑', prop: 'edit', type: 'primary', typeProp: 'editType', showText: true, access: '015003002'},
              {label: '删除', prop: 'delete', type: 'danger', showText: true, access: '015003005'},
            ],
          },
        ],
        data: [],
        searchClick: () => {
          this.searchClick();
        },
        btnClick: (type, row) => {
          this.tableBtnClick(type, row);
        },
      },
      dialogFormData: {
        state: false,
        title: '',
        data: {},
        rules: {
          incomeProject: [{required: true, message: '请输入标题', trigger: 'blur'}],
          payMode: [{required: true, message: '请选择收款方式', trigger: 'change'}],
          recordTime: [{required: true, message: '请选择时间', trigger: 'change'}],
          incomeAmount: [{required: true, message: '请输入收款金额', trigger: 'blur'}],
        },
      },
    }
  },
  methods: {
    btnClick(type) {
      switch (type) {
        case 'add':
          this.openDialog();
          break;
        case 'delete':
          this.deleteSelected();
          break;
      }
    },
    tableBtnClick(type, row) {
      switch (type) {
        case 'edit':
          if (row.editDisabled) {
            return;
          }
          this.openDialog(row);
          break;
        case 'delete':
          this.deleteRow(row);
          break;
        case 'audit':
          this.auditRow(row);
          break;
        case 'revAudit':
          this.revAuditRow(row);
          break;
      }
    },
    openDialog(row) {
      this.dialogFormData.title = row ? '编辑其他收入' : '新建其他收入';
      if (row) {
        const editData = JSON.parse(JSON.stringify(row));
        editData.recordTime = this.getRecordDateTime(row.recordTime || row.orderTime || row.createTime);
        this.dialogFormData.data = editData;
      } else {
        this.dialogFormData.data = {
          incomeProject: '',
          payMode: '',
          recordTime: this.$dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          incomeAmount: '',
          note: '',
        };
      }
      this.dialogFormData.state = true;
      this.$nextTick(() => {
        if (this.$refs.recordForm) {
          this.$refs.recordForm.clearValidate();
        }
      });
    },
    submitRecordForm() {
      this.$refs.recordForm.validate(valid => {
        if (valid) {
          this.saveClick();
        }
      });
    },
    saveClick() {
      const data = JSON.parse(JSON.stringify(this.dialogFormData.data));
      data.recordTime = this.getRecordDateTime(data.recordTime);
      data.payModeName = this.getPayModeName(data.payMode);
      data.payModeDisplay = this.getPayModeDisplay(data.payMode);
      if (data.id) {
        this.updateFinanceOrder(data);
      } else {
        this.createFinanceOrder(data);
      }
    },
    createFinanceOrder(data) {
      this.$POST("/customer/finance/income/order/create", this.buildCreateOrderParam(data), true, "保存中...", true, true).then(res => {
        const record = this.buildCreatedRecord(data, res.data);
        this.records.unshift(record);
        this.dialogFormData.state = false;
        this.$message.success("保存成功!");
        this.searchClick();
      });
    },
    updateFinanceOrder(data) {
      this.$POST("/customer/finance/income/order/update", this.buildUpdateOrderParam(data), true, "保存中...", true, true).then(() => {
        this.dialogFormData.state = false;
        this.$message.success("保存成功!");
        this.searchClick();
      });
    },
    buildUpdateOrderParam(data) {
      const param = this.buildCreateOrderParam(data);
      param.orderId = data.orderId || data.id;
      return param;
    },
    buildCreateOrderParam(data) {
      const amount = this.getNumberAmount(data.incomeAmount);
      const itemName = data.incomeProject || '其他收入';
      return {
        shopId: this.$store.state.shopInfo ? this.$store.state.shopInfo.id : '',
        orderType: "INCOME",
        bizType: "ORDER",
        recordTime: data.recordTime,
        items: [
          {
            itemName: itemName,
            itemDesc: data.note || '',
            itemType: "CUSTOM",
            remark: data.note || '',
            units: [
              {
                unitName: itemName,
                unitAmount: amount,
                quantity: 1,
                finalAmount: amount,
                source: "MANUAL",
                payments: [
                  {
                    payMethod: data.payMode,
                    payAmount: amount,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    buildCreatedRecord(data, serverData) {
      const record = Object.assign({}, data, serverData || {});
      record.id = record.id || this.getRowId();
      record.createTime = record.createTime || this.$dayjs().format('YYYY-MM-DD HH:mm:ss');
      record.auditState = record.auditState === undefined || record.auditState === null ? 0 : record.auditState;
      record.payModeName = this.getPayModeName(record.payMode);
      record.payModeDisplay = this.getPayModeDisplay(record.payMode);
      this.setRowAuditButtons(record);
      return record;
    },
    getNumberAmount(value) {
      const amount = Number(value);
      return Number.isNaN(amount) ? 0 : amount;
    },
    getRecordDateTime(value) {
      const time = value ? this.$dayjs(value) : this.$dayjs();
      return time.startOf('day').format('YYYY-MM-DD HH:mm:ss');
    },
    deleteSelected() {
      const list = this.tableData.data.filter(item => item.select && item.deleteBtn !== false);
      if (!list.length) {
        this.$message.warning("请选择要删除的数据!");
        return;
      }
      Promise.all(list.map(item => this.deleteFinanceOrder(item, false))).then(() => {
        this.searchClick();
        this.$message.success("删除成功!");
      });
    },
    deleteRow(row) {
      this.deleteFinanceOrder(row).then(() => {
        this.searchClick();
        this.$message.success("删除成功!");
      });
    },
    deleteFinanceOrder(row, isLoading = true) {
      return this.$POST("/customer/finance/income/order/delete", this.buildDeleteOrderParam(row), isLoading, "删除中...", true, true);
    },
    buildDeleteOrderParam(row) {
      const param = {};
      param.orderId = row.orderId || row.id;
      return param;
    },
    auditRow(row) {
      this.$POST("/customer/finance/income/order/audit", this.buildAuditOrderParam(row), true, "审核中...", true, true).then(() => {
        this.$message.success("审核成功!");
        this.searchClick();
      });
    },
    revAuditRow(row) {
      this.$POST("/customer/finance/income/order/unaudit", this.buildAuditOrderParam(row), true, "反审中...", true, true).then(() => {
        this.$message.success("反审成功!");
        this.searchClick();
      });
    },
    buildAuditOrderParam(row) {
      return {
        shopId: this.$store.state.shopInfo ? this.$store.state.shopInfo.id : '',
        financeOrderId: row.orderId || row.id,
      };
    },
    setRowAuditButtons(row) {
      const audited = row.financeAudit !== undefined && row.financeAudit !== null
          ? row.financeAudit !== 0 && row.financeAudit !== '0'
          : row.auditState === 1 || row.auditState === '1';
      row.auditBtn = !audited;
      row.revAuditBtn = audited;
      row.editBtn = true;
      row.editDisabled = audited;
      row.editType = audited ? 'info' : 'primary';
      row.deleteBtn = !audited;
    },
    searchClick() {
      const form = this.tableData.form;
      const param = {
        shopId: this.$store.state.shopInfo ? this.$store.state.shopInfo.id : '',
        orderType: "INCOME",
        current: form.page,
        size: form.limit,
        page: form.page,
        limit: form.limit,
        itemName: form.incomeProject,
        orderNo: form.orderNo,
        payMethod: form.payMode,
      };
      if (form.recordTime && form.recordTime.length === 2) {
        param.startTime = this.$dayjs(form.recordTime[0]).format('YYYY-MM-DD') + ' 00:00:00';
        param.endTime = this.$dayjs(form.recordTime[1]).format('YYYY-MM-DD') + ' 23:59:59';
      }
      this.$POST("/customer/finance/income/order/page", param, true, "查询中...", true, true).then(res => {
        const pageData = this.getPageData(res.data);
        const list = pageData.records.map(item => this.mapFinanceOrderRecord(item));
        list.forEach(item => {
          this.setRowAuditButtons(item);
        });
        this.records = list;
        this.tableData.data = list;
        this.tableData.form.total = pageData.total;
      });
    },
    getPageData(data) {
      if (Array.isArray(data)) {
        return {
          records: data,
          total: data.length,
        };
      }
      const pageData = data || {};
      const records = pageData.records || pageData.list || pageData.rows || [];
      return {
        records: Array.isArray(records) ? records : [],
        total: pageData.total || pageData.count || records.length || 0,
      };
    },
    mapFinanceOrderRecord(row) {
      const item = this.getFirstArrayItem(row.items);
      const unit = this.getFirstArrayItem(item.units);
      const payment = this.getFirstArrayItem(unit.payments);
      const payMode = this.getFirstValue(row.payMode, row.payMethod, payment.payMethod, '');
      const amount = this.getFirstValue(row.incomeAmount, row.paidAmount, row.totalAmount, row.orderAmount, row.finalAmount, unit.finalAmount, payment.payAmount, '');
      const record = Object.assign({}, row, {
        id: row.id || row.orderId,
        operateUserName: row.operateUserName || row.creatorName || '',
        incomeProject: row.incomeProject || row.itemName || item.itemName || unit.unitName || '',
        incomeAmount: amount,
        payMode: payMode,
        payModeName: this.getPayModeName(payMode),
        recordTime: this.formatRecordTime(row.recordTime || row.orderTime || row.createTime),
        note: row.note || row.remark || item.remark || item.itemDesc || '',
      });
      record.payModeDisplay = this.getPayModeDisplay(record.payMode);
      return record;
    },
    getFirstArrayItem(list) {
      return Array.isArray(list) && list.length ? list[0] : {};
    },
    getFirstValue(...values) {
      for (let i = 0; i < values.length; i++) {
        if (values[i] !== undefined && values[i] !== null && values[i] !== '') {
          return values[i];
        }
      }
      return '';
    },
    formatRecordTime(value) {
      if (!value) {
        return '';
      }
      const time = this.$dayjs(value);
      return time.isValid() ? time.format('YYYY-MM-DD') : value;
    },
    loadReceiveModes() {
      const shopInfo = this.$store.state.shopInfo || {};
      const shopId = shopInfo.id;
      if (!shopId) {
        this.setReceiveModeOptions(this.allowedReceiveModeList);
        return;
      }
      this.$GET("/customer/EomsShopReceiveMode/getReceiveModes?shopId=" + shopId).then(res => {
        this.setReceiveModeOptions(this.filterAllowedReceiveModes(res.data));
      }).catch(() => {
        this.setReceiveModeOptions(this.allowedReceiveModeList);
      });
    },
    filterAllowedReceiveModes(shopReceiveModes) {
      if (!Array.isArray(shopReceiveModes) || shopReceiveModes.length === 0) {
        return this.allowedReceiveModeList;
      }
      const modeMapByValue = new Map();
      const modeMapByName = new Map();
      shopReceiveModes.forEach(item => {
        const logicValue = Number(item.logicValue);
        if (!Number.isNaN(logicValue)) {
          modeMapByValue.set(logicValue, item);
        }
        if (item.displayValue) {
          const displayValue = item.displayValue === '其它' ? '其他' : item.displayValue;
          modeMapByName.set(displayValue, item);
        }
      });
      const list = this.allowedReceiveModeList.reduce((result, item) => {
        const match = item.displayValue === '银行卡'
            ? modeMapByName.get(item.displayValue)
            : modeMapByValue.get(item.logicValue) || modeMapByName.get(item.displayValue);
        if (match) {
          const logicValue = Number(match.logicValue);
          result.push({
            displayValue: item.displayValue,
            logicValue: Number.isNaN(logicValue) ? item.logicValue : logicValue,
          });
        }
        return result;
      }, []);
      if (this.tableData.form.payMode && !list.some(item => item.logicValue === this.tableData.form.payMode)) {
        this.tableData.form.payMode = '';
      }
      if (this.dialogFormData.data && this.dialogFormData.data.payMode
          && !list.some(item => item.logicValue === this.dialogFormData.data.payMode)) {
        this.dialogFormData.data.payMode = '';
      }
      return list.length ? list : this.allowedReceiveModeList;
    },
    setReceiveModeOptions(list) {
      this.receiveModeList = list;
      this.$tools.getIndex(this.tableData.column, "payModeDisplay").tags = list.map(item => ({
        value: item.logicValue,
        text: item.displayValue,
        type: '',
      }));
    },
    getPayModeName(value) {
      const item = this.receiveModeList.find(mode => mode.logicValue === value);
      return item ? item.displayValue : value;
    },
    getPayModeIcon(value) {
      const iconMap = {
        1: require('@/assets/meituan.png'),
        2: require('@/assets/weixin.png'),
        3: require('@/assets/zhifubao.png'),
        4: require('@/assets/xianjin.png'),
        5: require('@/assets/qita.png'),
        6: require('@/assets/qita.png'),
        7: require('@/assets/meituan.png'),
        8: require('@/assets/meituan.png'),
        9: require('@/assets/douyin.png'),
        10: require('@/assets/kuaishou.png'),
        11: require('@/assets/daijinquan.png'),
        12: require('@/assets/fukuanma.png'),
        13: require('@/assets/weimeng.png'),
        14: require('@/assets/meituan.png'),
        15: require('@/assets/meituan.png'),
        16: require('@/assets/weidian.png'),
        18: require('@/assets/fankeyuding.png'),
        20: require('@/assets/huifu.png'),
        21: require('@/assets/gaode.png'),
        23: require('@/assets/maitao.png'),
      };
      return iconMap[value] || '';
    },
    getPayModeDisplay(value) {
      const icon = this.getPayModeIcon(value);
      const text = this.getPayModeName(value) || '-';
      if (!icon) return `<div class="finance-pay-display"><span>${text}</span></div>`;
      return `<div class="finance-pay-display"><img class="finance-pay-display-icon" src="${icon}" /><span>${text}</span></div>`;
    },
    handleMoneyInput(prop) {
      let value = this.dialogFormData.data[prop] || '';
      value = value.replace(/[^\d.]/g, '');
      value = value.replace(/^\./g, '');
      value = value.replace(/\.{2,}/g, '.');
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      value = value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2');
      this.dialogFormData.data[prop] = value;
    },
    getRowId() {
      return this.$tools.getUUID ? this.$tools.getUUID() : this.$dayjs().valueOf() + '';
    },
  },
  mounted() {
    this.loadReceiveModes();
    this.searchClick();
  },
  activated() {
    this.loadReceiveModes();
    this.searchClick();
  },
}
</script>

<style scoped>
:deep(.finance-record-dialog .el-dialog) {
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 26px 80px rgba(15, 23, 42, 0.22);
}

:deep(.finance-record-dialog .el-dialog__header) {
  margin-right: 0;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #dbe7ff;
  background:
      radial-gradient(circle at left top, rgba(59, 130, 246, 0.18), transparent 34%),
      linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

:deep(.finance-record-dialog .el-dialog__body) {
  padding: 18px 22px 10px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

:deep(.finance-record-dialog .el-dialog__footer) {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 24px 20px;
  border-top: 1px solid #e8eef8;
  background: #ffffff;
}

:deep(.finance-record-dialog .el-dialog__headerbtn) {
  top: 18px;
  right: 18px;
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.82);
  transition: background-color 0.2s ease, transform 0.2s ease;
}

:deep(.finance-record-dialog .el-dialog__headerbtn:hover) {
  background: #ffffff;
  transform: rotate(90deg);
}

:deep(.finance-record-dialog .el-dialog__headerbtn .el-dialog__close) {
  margin: 0;
  font-size: 16px;
  line-height: 1;
}

.target-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-right: 38px;
}

.target-title-block {
  min-width: 0;
}

.target-title-block h3 {
  margin: 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.finance-record-form {
  padding: 4px 2px 0;
}

.finance-record-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 20px;
  row-gap: 4px;
}

.finance-record-form-item-full {
  grid-column: 1 / -1;
}

.finance-pay-option {
  display: flex;
  align-items: center;
  gap: 6px;
}

.finance-pay-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
}

:deep(.finance-pay-display) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 28px;
}

:deep(.finance-pay-display-icon) {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
}

:deep(.finance-record-form .el-form-item) {
  margin-bottom: 18px;
}

:deep(.finance-record-form .el-input),
:deep(.finance-record-form .el-select),
:deep(.finance-record-form .el-date-editor) {
  width: 100%;
}

:deep(.finance-record-form .el-input__wrapper),
:deep(.finance-record-form .el-textarea__inner) {
  border-radius: 10px;
}

.target-footer-actions {
  display: grid;
  grid-template-columns: repeat(2, 96px);
  justify-content: end;
  gap: 12px;
  width: 204px;
  overflow: hidden;
}

.target-close-action {
  transform: translateX(108px);
}

.target-footer-actions.is-edit .target-close-action {
  transform: translateX(0);
}

.target-save-action {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(6px);
}

.target-save-action.is-visible {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
}

:deep(.finance-record-dialog .el-dialog__footer .el-button) {
  min-width: 96px;
  height: 40px;
  margin-left: 0;
  border-radius: 12px;
  font-weight: 600;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, filter 0.2s ease, opacity 0.18s ease, visibility 0.18s ease, transform 0.18s ease;
}

:deep(.finance-record-dialog .el-dialog__footer .el-button--default) {
  border-color: #d9e3f0;
  color: #475569;
  background: #ffffff;
}

:deep(.finance-record-dialog .el-dialog__footer .el-button--default:hover) {
  border-color: #93c5fd;
  color: #2563eb;
  background: #f8fbff;
}

:deep(.finance-record-dialog .el-dialog__footer .el-button--primary) {
  border-color: transparent;
  background: linear-gradient(135deg, #2563eb 0%, #0ea5e9 100%);
  box-shadow: 0 14px 28px rgba(37, 99, 235, 0.22);
}

:deep(.finance-record-dialog .el-dialog__footer .el-button--primary:hover) {
  filter: brightness(1.03);
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  :deep(.finance-record-dialog .el-dialog) {
    width: calc(100vw - 24px) !important;
  }

  .finance-record-grid {
    grid-template-columns: 1fr;
  }

  .target-footer-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  :deep(.finance-record-dialog .el-dialog__headerbtn),
  :deep(.finance-record-dialog .el-dialog__footer .el-button),
  .target-close-action,
  .target-save-action {
    transition: none;
  }
}
</style>
